// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23RdZ","select":"styles_select__1c9Xg"};